import { LoanCardTypeEnum } from '@/api/rights/types';
import ProductCommodity from '@/shared/commodity';
import type { ViewConfig } from '../../../ViewRegistry';
import JiGouCard from './index.vue';

export const jiGouCardConfig: ViewConfig = {
  viewType: 'jigou-card',
  viewName: '机构卡购买卡片',
  component: JiGouCard as unknown as ViewConfig['component'],
  priority: 10,
  match: (context) => {
    // 匹配规则：产品ID不等于8180 && 是外量外部闭环权益
    const productId = (context.channel)?.productId;
    const { rightSummaryData } = context;
    if (productId === undefined) return false;
    return (productId !== ProductCommodity.AUTARKY_B_COMMODITY)
    && (rightSummaryData?.loanCardType === LoanCardTypeEnum.CHANNEL_RIGHT);
  },
  props: (context) => ({
    amount: context.amount,
    showSpeed: context.showSpeed,
    checkStatus: context.checkStatus,
    channel: context.channel,
    normalTextList: ['不可享受专属的生活权益', '不可享受专属权益服务'],
  }),
  description: '机构卡购买卡片',
};

export default jiGouCardConfig;
